import { Stack } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WhiteLabelLeftSideProps as Props } from './types';
import { WhiteLabelTextField } from './components/white-label-text-field';
import { RenderFields } from './components/render-fields';

export const WhiteLabelLeftSide = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('WhiteLabelLeftSide', className)}
      sx={SX.root}
    >
      <Stack gap={1}>
        <RenderFields>
          {(item) => (
            <Stack gap={1}>
              {item.map((field) => (
                <WhiteLabelTextField key={field.label} item={field} />
              ))}
            </Stack>
          )}
        </RenderFields>
      </Stack>
    </Styled.Wrapper>
  );
});

WhiteLabelLeftSide.displayName = 'WhiteLabelLeftSide';
